export const ZET_SALES = 'ZET_SALES'
export const MAGNET = 'MAGNET'
export const REFERRAL = 'REFERRAL'
export const OTHER = 'OTHER'
export const ZET_REFERRAL = 'ZET_REFERRAL'
export const BONUS_EARNINGS = 'Bonus Earnings'

export const enum EarningType {
  ZET_SALES = 'zetSalesEarnings',
  MAGNET = 'magnetEarnings',
  REFERRAL = 'referralEarnings',
  OTHER = 'otherEarnings',
  ZET_REFERRAL = 'zetReferralEarnings',
}
